import { RefObject, useMemo } from 'react'

export const useHasScroll = (ref: RefObject<HTMLDivElement | null>) => {
  const hasScroll = useMemo(() => {
    if (ref?.current) {
      const { scrollHeight } = ref.current
      if (scrollHeight > window.innerHeight) {
        return true
      }
      return false
    }
    return false
  }, [ref])

  return hasScroll
}
